import React from 'react'
import useSWR from 'swr'
import Fetch from 'lib/fetch'
import Fetcher from 'lib/fetcher'
import Button from 'lib/button'

const AddUserButton = ({ model }) => {
  return (
    <Button
      label="+"
      className="whitespace-nowrap text-sm"
      onClick={() => (model.addingUser = !model.addingUser)}
    />
  )
}

export default AddUserButton
